var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quill-editor',{attrs:{"options":_vm.editorOption},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},[_c('div',{attrs:{"slot":"toolbar","id":"toolbar"},slot:"toolbar"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }